import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, skipWhile, switchMap, take, tap } from 'rxjs/operators';
import { Role } from 'src/app/core/models/role';
import { AuthService } from 'src/app/core/services/auth.service';
import { FilialAdminService } from 'src/app/core/services/filial.admin.service';
import { FilialService } from 'src/app/core/services/filial.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { CompanyService } from 'src/app/core/services/company.service';

@Component({
  selector: 'app-filials-list',
  templateUrl: './filials-list.component.html',
  styleUrls: ['./filials-list.component.css'],
})
export class FilialsListComponent implements OnInit, OnDestroy {
  companyId: string;
  filials: any;
  filial: any;
  toggleDeleteFilial = false;
  currentUser: any;
  isLoading = false;
  company: any;
  sub: Subscription;

  searchControl = new FormControl();
  formCtrlSub: Subscription;

  searchParam: string;

  isAllFilials: boolean = false;
  companies:any;

  page = 1;
  perPage = 6;


  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private filialService: FilialService,
    private toastr: ToastrService,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private translate: TranslateService,
    private filialAdminService: FilialAdminService,
    private companyService: CompanyService
  ) {}

  ngOnInit(): void {
    this.sub = this.authService.LoggedinUser.pipe(
      skipWhile((user) => user === null),
      take(1)
    ).subscribe((user) => {
      console.log('user', user);
      this.currentUser = user;

      if (this.currentUser.role.name === 'root' && this.router.url.includes('/root/filials')) {
        this.isAllFilials = true;
      }

      if (this.currentUser?.role?.name === Role.USER) {
        this.companyId = this.currentUser.companyId;
        this.loadFilials();
      } else if (this.currentUser?.role?.name === Role.ROOT) {
        
        if(!this.isAllFilials) {
          this.route.parent.parent.params.subscribe((res) => {
            this.companyId = res.id || this.currentUser.companyId;
          });
  
          this.route.parent.parent.data.subscribe((res) => {
            this.company = res.company;
            this.breadcrumbService.set('@companyName', this.company.name);
          });
        } else {
          this.companyService.getCompanies().subscribe(res => {
            this.companies = res;
          })
        }
        this.loadFilials();
      } else {
        this.isLoading = true;
        if(this.currentUser.role.name === Role.FILIALADMIN) {
          this.companyId = this.currentUser.companyId;
        }
        this.filialAdminService
          .getAllFilialsAssignToFilialAdmin(this.currentUser.id)
          .subscribe(
            (res) => {
              this.filials = res;
              this.isLoading = false;
            },
            (err) => {
              this.isLoading = false;
            }
          );
      }
    });
    this.formCtrlSub = this.searchControl.valueChanges
    .pipe(
      debounceTime(800),
      distinctUntilChanged(),
      tap((value) => {
        this.isLoading = true;
        this.searchParam = value;
      }),
      switchMap((changedValue) => this.getFilials())
    )
    .subscribe((res) => {
      console.log('hmmm')
      this.filials = res;
      this.isLoading = false;
    });
  }

  onSelectionChange(selectedOption: any) {
    if(selectedOption) {
      this.companyId = selectedOption.id;
    } else {
      this.companyId = null;
    }
    this.loadFilials();
  }
  
  getFilials(): Observable<any> {
    console.log('dsadsa')
    if(this.isAllFilials) {
      return this.filialService.getAllFilials(this.page, this.perPage, this.companyId, this.searchParam)
    } else {
      return this.filialService.getCompanyFilials(this.companyId, this.searchParam);
    }
  }

  loadFilials() {
    this.isLoading = true;
    this.getFilials().subscribe(
      (res) => {
        this.filials = res;
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  onDelete(company) {
    this.filial = company;
    this.toggleDeleteFilial = true;
  }

  deleteFilial() {
    this.toggleDeleteFilial = false;
    this.filialService.deleteFilial(this.companyId, this.filial.id).subscribe(
      (res) => {
        this.loadFilials();
        this.translate
          .get('filials.filialDeleted', { name: this.filial.name })
          .subscribe((res: string) => {
            this.toastr.success(res);
          });
        this.filial = null;
      },
      (err) => {}
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  jumpToPage(event: any) {
    this.page = event;
    this.loadFilials();
  }
}
